import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const RabbyIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest} strokeColor="currentColor">
      <path
        d="M20.5534 13.0829C21.2322 11.5614 17.8764 7.31041 14.6704 5.53938C12.6496 4.1674 10.5439 4.35589 10.1175 4.95831C9.18157 6.28033 13.2166 7.40059 15.9151 8.7078C15.335 8.96059 14.7884 9.41425 14.467 9.99442C13.4609 8.89239 11.2528 7.94336 8.66177 8.7078C6.91577 9.22295 5.46471 10.4374 4.90385 12.2717C4.76758 12.211 4.61672 12.1772 4.45798 12.1772C3.85097 12.1772 3.35889 12.6709 3.35889 13.28C3.35889 13.889 3.85097 14.3828 4.45798 14.3828C4.57049 14.3828 4.92227 14.3071 4.92227 14.3071L10.5439 14.3479C8.29572 17.9266 6.51897 18.4497 6.51897 19.0697C6.51897 19.6896 8.21899 19.5216 8.85733 19.2905C11.913 18.1843 15.195 14.7364 15.7582 13.7439C18.1232 14.04 20.1108 14.075 20.5534 13.0829Z"
        fill="url(#paint0_linear_3469_143)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9148 8.70796C15.9149 8.70805 15.915 8.7081 15.9152 8.70815C16.0402 8.65874 16.02 8.47335 15.9857 8.3278C15.9067 7.99326 14.5447 6.64373 13.2656 6.03927C11.5229 5.21563 10.2395 5.25805 10.0498 5.6376C10.4048 6.36773 12.0507 7.05318 13.7696 7.7691C14.503 8.07454 15.2497 8.38551 15.9151 8.70782C15.915 8.70787 15.9149 8.70791 15.9148 8.70796Z"
        fill="url(#paint1_linear_3469_143)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7031 16.0559C13.3506 15.9208 12.9524 15.7968 12.4998 15.6843C12.9824 14.8177 13.0837 13.5349 12.6279 12.7238C11.9882 11.5855 11.1852 10.9797 9.31912 10.9797C8.29279 10.9797 5.52951 11.3266 5.48043 13.6411C5.47528 13.8839 5.48034 14.1065 5.49782 14.3112L10.5438 14.3478C9.86357 15.4307 9.22645 16.2338 8.66864 16.8445C9.33834 17.0166 9.891 17.1612 10.3984 17.2939C10.8798 17.4198 11.3205 17.5351 11.7817 17.6532C12.4774 17.1445 13.1315 16.59 13.7031 16.0559Z"
        fill="url(#paint2_linear_3469_143)"
      />
      <path
        d="M4.8366 14.0732C5.04271 15.8315 6.03862 16.5205 8.0736 16.7244C10.1086 16.9284 11.2759 16.7916 12.83 16.9334C14.1279 17.0519 15.2868 17.7156 15.7168 17.4862C16.1037 17.2798 15.8872 16.5341 15.3695 16.0557C14.6984 15.4356 13.7695 15.0044 12.1351 14.8514C12.4609 13.9566 12.3696 12.702 11.8637 12.0193C11.1323 11.0324 9.78224 10.5862 8.0736 10.7811C6.28842 10.9848 4.57789 11.8667 4.8366 14.0732Z"
        fill="url(#paint3_linear_3469_143)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3469_143"
          x1="8.45847"
          y1="11.7355"
          x2="20.4132"
          y2="15.1143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3469_143"
          x1="18.3951"
          y1="11.5076"
          x2="9.74441"
          y2="2.86495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8697FF" />
          <stop offset="1" stopColor="#8697FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3469_143"
          x1="13.9429"
          y1="16.358"
          x2="5.64712"
          y2="11.6045"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8697FF" />
          <stop offset="1" stopColor="#8697FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3469_143"
          x1="9.17188"
          y1="11.6459"
          x2="14.7932"
          y2="18.7643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.983895" stopColor="#D1D8FF" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}
